module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-10-b1624832914bc94e021ca8ec0d493aa4.jpg";